/**
 * The custom roles that reach the Delivery tracking hub (avatar menu) and, from
 * it, Territory Management at `/delivery/territories`.
 *
 * One list, read by the avatar menu (ModernTopbar) and by the sidebar's
 * Delivery setup entry (PRX-126), so the two ways to reach delivery territories
 * can never disagree about who may use them.
 */
export const DELIVERY_TRACKING_ROLES: string[] = [
  'pharmacy_admin',
  'wally_dev_admin',
  'clinical_pharmacist',
  'data_analyst',
  'logistics',
  'pharmacy_ops',
  'infusion_scheduler',
  'toxins',
  'pharmacy_technician',
  'onepoint',
  'onepoint_manager',
];
